import React from "react"
import ThankYou from "../../static/ThankYou/ThankYou"
import * as styles from "./SupplierSignupComplete.module.scss"

const SupplierSignupComplete = ({ userAttributes }) => (
  <ThankYou
    title="Thanks for signing up!"
    text="Your application is now complete. For any enquiries, please email:"
    button={{
      externalLink: true,
      design: "text",
      text: "supplier@houseofpartyplanning.com",
      link: "mailto:supplier@houseofpartyplanning.com",
      color: "pink",
    }}
  />
)

export default SupplierSignupComplete
